(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aa-star-rating"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.aaStarRatingInit) return;
    window.aaStarRatingInit = true;

    // Smooth-scroll to the reviews section when it is on this page; otherwise the link opens its href.
    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-aa-sr]');
      if (!link) return;
      var target;
      try {
        target = document.querySelector(link.dataset.target);
      } catch (e) {
        return;
      }
      if (!target) return;
      event.preventDefault();
      var offset = parseInt(link.dataset.offset, 10) || 0;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(top, 0), behavior: reduce ? 'auto' : 'smooth' });
      if (history.replaceState) history.replaceState(null, '', link.dataset.target.charAt(0) === '#' ? link.dataset.target : location.hash);
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });

    // sync: copy the average + count from the reviews section on the page.
    function sync() {
      document.querySelectorAll('[data-aa-sr][data-sync]').forEach(function (link) {
        var source;
        try {
          source = document.querySelector(link.dataset.target);
        } catch (e) {
          return;
        }
        if (!source || !source.dataset.avg) return;
        var avg = parseFloat(source.dataset.avg) || 0;
        var count = parseInt(source.dataset.count, 10) || 0;
        var lang = link.dataset.lang || 'en';
        var word = link.dataset.label || (count === 1 ? link.dataset.one : link.dataset.many);
        var ratingText = new Intl.NumberFormat(lang, { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(avg);
        var countText = new Intl.NumberFormat(lang).format(count);
        var fill = link.querySelector('[data-aa-sr-fill]');
        var ratingEl = link.querySelector('[data-aa-sr-rating]');
        var countEl = link.querySelector('[data-aa-sr-count]');
        if (fill) fill.style.width = Math.min(avg, 5) * 20 + '%';
        if (ratingEl) ratingEl.textContent = ratingText;
        if (countEl) countEl.textContent = countText + ' ' + word;
        link.setAttribute('aria-label', ratingText + ' ' + link.dataset.of + ', ' + countText + ' ' + word);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
    else sync();
    document.addEventListener('shopify:section:load', sync);
  })();
  } catch(e) { console.error(e); }
})();

})();
